import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { stylesPdf } from '.';
import { dateformat } from '../../helpers';
import { Config } from '../../widgets/template/Config';

const styles = {
  footer: {
    ...stylesPdf.row,
    justifyContent: 'space-between',
  },
  footerText: {
    ...stylesPdf.title,
    fontSize: 5,
  },
};

const FooterPdf = () => {
  return (
    <View style={styles.footer}>
      <Text style={styles.footerText}>{Config.onEDU}</Text>
      <Text style={styles.footerText}>{dateformat(null, { full: true })}</Text>
    </View>
  );
};

export default FooterPdf;
